'use client';

import { c as _c } from "react/compiler-runtime";
import type { AdvancedMentoringProductDTO, BasicMentoringProductDTO } from '@algoacademy/backend/modules/payment/endpoints/mutations/stripe-checkout/input.dto/input.dto';
import { Button } from '@algoacademy/design-system/web/actions/Button';
import { useState } from 'react';
import { BuyData } from '../BuyData';
import { ScheduleAppointmentDialog } from '../ScheduleAppointmentDialog';
type PricingCardProps = {
  mentoringProduct: BasicMentoringProductDTO | AdvancedMentoringProductDTO;
};
export function PricingCard(t0) {
  const $ = _c(10);
  const {
    mentoringProduct
  } = t0;
  const [isScheduleAppointmentDialogOpen, setIsScheduleAppointmentDialogOpen] = useState(false);
  let t1;
  if ($[0] !== mentoringProduct) {
    t1 = <BuyData mentoringProduct={mentoringProduct} />;
    $[0] = mentoringProduct;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex w-full flex-col items-center gap-3"><Button size="xl" className="w-full" onClick={() => setIsScheduleAppointmentDialogOpen(true)}>Umów bezpłatne spotkanie</Button><Button plain={true} size="xl" className="w-full" href="/regulamin">Szczegóły subskrypcji</Button></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsScheduleAppointmentDialogOpen(false);
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== isScheduleAppointmentDialogOpen || $[5] !== mentoringProduct) {
    t4 = <ScheduleAppointmentDialog mentoringProduct={mentoringProduct} isOpen={isScheduleAppointmentDialogOpen} onClose={t3} />;
    $[4] = isScheduleAppointmentDialogOpen;
    $[5] = mentoringProduct;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t4) {
    t5 = <>{t1}{t2}{t4}</>;
    $[7] = t1;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}